// removed by extract-text-webpack-plugin
module.exports = {"root":"_1Tj9L"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@snapask/common-components/styles/alertBannerTheme/success.scss
// module id = 903
// module chunks = 9